import Ajv from "ajv";
import addFormats from "ajv-formats";
export class AjvJsonValidator {
    constructor() {
        this._ajv = new Ajv({ removeAdditional: true });
        addFormats(this._ajv);
    }
    validate(schema, data) {
        return this._ajv.validate(schema, data) ? true : false;
    }
}
